/* hs-eslint ignored failing-rules */

/* eslint-disable no-bitwise */
'use es6';

import { combineReducers } from 'redux';
import { UNINITIALIZED, PENDING, FAILED, SUCCEEDED } from 'DesignData/enums/RequestStatus';
import Revision from 'DesignData/models/revisions/Revision';
import { CUSTOM_WIDGET_REVISIONS_FETCH, CUSTOM_WIDGET_BUFFER_PUBLISH, GLOBAL_WIDGET_REVISIONS_FETCH, GLOBAL_WIDGET_PUBLISH, GLOBAL_WIDGET_RENAME, GLOBAL_WIDGET_REVERT, GLOBAL_WIDGET_EDIT_SMART_RULES, GLOBAL_WIDGET_REMOVE_SMART_RULES, LAYOUT_REVISIONS_FETCH, LAYOUT_PUBLISH, TEMPLATE_REVISIONS_FETCH, TEMPLATE_BUFFER_PUBLISH, CUSTOM_WIDGET_REVERT, LAYOUT_REVERT, TEMPLATE_BUFFER_REVERT, RAW_ASSET_REVISIONS_FETCH, RAW_ASSET_PUBLISH, RAW_ASSET_REVERT } from 'DesignData/actions/ActionTypes';
import { CUSTOM_WIDGET, GLOBAL_WIDGET, LAYOUT, TEMPLATE, RAW_ASSET } from 'DesignData/constants/RevisionTypes';

function getByIdReducer(fetchActionType) {
  return (state = {}, action) => {
    const {
      resourceId,
      revisions,
      offset
    } = action;

    switch (action.type) {
      case fetchActionType:
        {
          let revisionsModels = state[resourceId] || [];

          if (revisions && revisions.length) {
            revisionsModels = revisions.map(_revision => new Revision(_revision));

            if (offset) {
              revisionsModels = state[resourceId].concat(revisionsModels);
            }
          }

          return Object.assign({}, state, {
            [resourceId]: revisionsModels
          });
        }

      default:
        {
          return state;
        }
    }
  };
}

function getFetchStatusByIdReducer(fetchActionType, publishActionTypes) {
  return (state = {}, action) => {
    if (action.type === fetchActionType) {
      const {
        resourceId,
        revisions,
        error
      } = action;
      const revisionsFetchStatus = {
        fetched: Boolean(revisions || error),
        error,
        fetchedAllRevisions: Boolean(revisions && !revisions.length)
      };
      return Object.assign({}, state, {
        [resourceId]: revisionsFetchStatus
      });
    }

    if (publishActionTypes.indexOf(action.type) > -1) {
      const resourceId = action.layoutId || action.templateId || action.customWidgetId || action.globalWidgetId;
      const revisionsFetchStatus = state[resourceId];
      return Object.assign({}, state, {
        [resourceId]: Object.assign({}, revisionsFetchStatus, {
          fetched: false
        })
      });
    }

    return state;
  };
}

function getRevisionsReducer(fetchActionType, publishActionTypes) {
  return combineReducers({
    byId: getByIdReducer(fetchActionType),
    fetchStatusById: getFetchStatusByIdReducer(fetchActionType, publishActionTypes)
  });
}
/**
 * NOTE: The following code/sub-reducer is used strictly for revisions in IDE.
 */


function getIsFetchAction(actionType) {
  const fetchActionTypes = [CUSTOM_WIDGET_REVISIONS_FETCH, GLOBAL_WIDGET_REVISIONS_FETCH, LAYOUT_REVISIONS_FETCH, TEMPLATE_REVISIONS_FETCH, RAW_ASSET_REVISIONS_FETCH];
  return !!~fetchActionTypes.indexOf(actionType);
}

function getIsPublishAction(actionType) {
  const publishActionTypes = [CUSTOM_WIDGET_BUFFER_PUBLISH, CUSTOM_WIDGET_REVERT, GLOBAL_WIDGET_PUBLISH, GLOBAL_WIDGET_RENAME, GLOBAL_WIDGET_REVERT, GLOBAL_WIDGET_EDIT_SMART_RULES, GLOBAL_WIDGET_REMOVE_SMART_RULES, LAYOUT_PUBLISH, LAYOUT_REVERT, TEMPLATE_BUFFER_PUBLISH, TEMPLATE_BUFFER_REVERT, RAW_ASSET_PUBLISH, RAW_ASSET_REVERT];
  return !!~publishActionTypes.indexOf(actionType);
}

const defaultRevisionsData = {
  order: [],
  revisions: {},
  fetchStatus: UNINITIALIZED,
  fetchError: null,
  total: 0
};

function revisionsDataByResourceId(state = defaultRevisionsData, action) {
  const isFetchAction = getIsFetchAction(action.type);
  const isPublishAction = getIsPublishAction(action.type);

  if (isFetchAction) {
    const {
      revisions,
      error,
      total
    } = action;

    if (!(revisions || error)) {
      return Object.assign({}, state, {
        order: [],
        fetchStatus: PENDING,
        fetchError: null
      });
    }

    if (error) {
      return Object.assign({}, state, {
        fetchStatus: FAILED,
        fetchError: error
      });
    }

    const newOrder = revisions.map(revision => revision.id);
    const newRevisions = revisions.reduce((hash, revision) => {
      hash[revision.id] = new Revision(revision);
      return hash;
    }, state.revisions);
    return {
      order: newOrder,
      revisions: newRevisions,
      fetchStatus: SUCCEEDED,
      fetchError: null,
      total
    };
  }

  if (isPublishAction) {
    return defaultRevisionsData;
  }

  return state;
}

function byId(state = {}, action) {
  const isFetchAction = getIsFetchAction(action.type);
  const isPublishAction = getIsPublishAction(action.type);

  if (isFetchAction || isPublishAction) {
    const {
      resourceId
    } = action;
    const revisionsData = revisionsDataByResourceId(state[resourceId], action);
    return Object.assign({}, state, {
      [resourceId]: revisionsData
    });
  }

  return state;
}
/**
 * END IDE REVISIONS CODE
 */


export default combineReducers({
  byId,
  [CUSTOM_WIDGET]: getRevisionsReducer(CUSTOM_WIDGET_REVISIONS_FETCH, [CUSTOM_WIDGET_BUFFER_PUBLISH, CUSTOM_WIDGET_REVERT]),
  [GLOBAL_WIDGET]: getRevisionsReducer(GLOBAL_WIDGET_REVISIONS_FETCH, [GLOBAL_WIDGET_PUBLISH, GLOBAL_WIDGET_RENAME, GLOBAL_WIDGET_REVERT, GLOBAL_WIDGET_EDIT_SMART_RULES, GLOBAL_WIDGET_REMOVE_SMART_RULES]),
  [LAYOUT]: getRevisionsReducer(LAYOUT_REVISIONS_FETCH, [LAYOUT_PUBLISH, LAYOUT_REVERT]),
  [TEMPLATE]: getRevisionsReducer(TEMPLATE_REVISIONS_FETCH, [TEMPLATE_BUFFER_PUBLISH, TEMPLATE_BUFFER_REVERT]),
  [RAW_ASSET]: getRevisionsReducer(RAW_ASSET_REVISIONS_FETCH, [RAW_ASSET_PUBLISH, RAW_ASSET_REVERT])
});